import React from "react";
import { Box, Grid, Text } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { ThemedCaption } from "./ThemedLayout";

// Scores from the Framer page. Jungle first, then the best of four anonymized competitors.
export const SCORE_ROWS = [
  { label: "Plausible wrong answers", jungle: 69, competitors: [55, 53, 28, 56] },
  { label: "Easy to understand", jungle: 94, competitors: [92, 85, 88, 89] },
  { label: "Relevance to your document", jungle: 99, competitors: [93, 78, 99, 33] },
];

// One row per metric on a 0–100 track: Jungle's bar in the accent with its score, the best rival as a
// thinner bar beneath with an inline label. Bars are drawn to true proportion.
export function ScoreDotPlot() {
  const theme = useLandingTheme();
  const rivalBar = theme.chart.competitors[0];
  return (
    <Box>
      {SCORE_ROWS.map((row, rowIndex) => {
        const bestCompetitor = Math.max(...row.competitors);
        return (
          <Grid
            key={row.label}
            templateColumns={{ base: "120px 1fr 60px", md: "200px 1fr 80px" }}
            columnGap={{ base: "16px", md: "28px" }}
            alignItems="center"
            py="24px"
            borderTop={`1px solid ${theme.color.border}`}
            borderBottom={rowIndex === SCORE_ROWS.length - 1 ? `1px solid ${theme.color.border}` : "none"}
          >
            <Text fontFamily={theme.font.body} fontSize="16px" fontWeight={600} color={theme.color.heading} lineHeight={1.3}>
              {row.label}
            </Text>
            {/* The track is the full column; each bar is a percentage of it. */}
            <Box>
              <Box h="20px" w={`${row.jungle}%`} bg={theme.chart.jungle} borderRadius="2px" />
              <Box h="8px" w={`${bestCompetitor}%`} bg={rivalBar} borderRadius="2px" mt="8px" />
            </Box>
            <Box textAlign="right">
              <Text fontFamily={theme.font.display} fontWeight={theme.heading.weight} fontSize={{ base: "28px", md: "36px" }} lineHeight={1} color={theme.chart.jungle} sx={{ fontVariantNumeric: "tabular-nums" }}>
                {row.jungle}
              </Text>
              <Text fontFamily={theme.font.body} fontSize="12px" color={theme.color.text} whiteSpace="nowrap" mt="6px" sx={{ fontVariantNumeric: "tabular-nums" }}>
                {bestCompetitor === row.jungle ? `rival ${bestCompetitor} (tie)` : `rival ${bestCompetitor}`}
              </Text>
            </Box>
          </Grid>
        );
      })}
      <ThemedCaption mt="16px" fontSize="13px" color={theme.color.text} opacity={0.8}>
        Scores out of 100. Rivals are Quizlet, Turbo, Gizmo and Studyfetch; every platform generated questions from the same three documents and an LLM judge scored them blind.
      </ThemedCaption>
    </Box>
  );
}
